
import React from 'react';

interface TipAnimationProps {
  show: boolean;
  amount: number;
}

const TipAnimation: React.FC<TipAnimationProps> = ({ show, amount }) => {
  if (!show) return null;

  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <div className="text-4xl font-bold text-primary animate-scale-out">
        +{amount} 🎁
      </div>
    </div>
  );
};

export default TipAnimation;
